import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { select, Store } from '@ngrx/store';
import { getDataLayer } from '@app/analytics/reducers';
import { IAppState } from '@app/store';

@Injectable({
  providedIn: 'root'
})
export class DataLayerService {
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private store: Store<IAppState>) {}

  // Tag commander's DataLayer
  flush(): void {
    if (!this.isBrowser) {
      return;
    }
    this.store.pipe(select(getDataLayer)).subscribe(
      dL => (window['tc_vars'] = dL || {}),
      error => {
        // Silently fails
      }
    );
  }

  // Google Tag Manager's DataLayer
  pushGA(payload: any): void {
    if (!this.isBrowser) {
      return;
    }

    window['dataLayer'] = window['dataLayer'] || [];

    window['dataLayer'].push(payload);
  }
}
